import React from 'react'
import { useNavigate } from 'react-router-dom'
import bookmaker from '../../assets/icons/bookmaker-svgrepo-com.svg'
import next from '../../assets/icons/back-svgrepo-com.svg'
import { GoLocation } from 'react-icons/go'
import ImageWithFallback from '../ImageWithFallback'
import TruncateText from "../../../components/TruncateText"
import {END_POINT } from '../../../utils/constant'

const RecruiterCard = ({key, item}) => {
  const navigate = useNavigate()

  return (
    <div key={key} onClick={() => navigate("/recruteur/" + item.id)} className='bg-white border rounded-lg overflow-hidden py-6 px-6 transition-all ease-in hover:border-gray-400 cursor-pointer'>
        <div className="flex justify-between items-start">
            <div className='flex flex-row gap-3 mb-3'>
                <div className='border bg-slate-50 rounded-sm flex items-center justify-center w-20 h-14'>
                    {/* Logo ou icône */}
                    <ImageWithFallback src={END_POINT+"/storage"+item?.organisation_profile?.logo} alt="logo" defaultType='logo'  className=''/>
                </div>
                <div>
                  <div className='text-lg font-semibold text-start'>{item?.organisation_profile?.company_name}</div>
                  <div className='text-sm text-primary-text flex items-center gap-1 text-start'> 
                    <GoLocation/>
                    {item?.organisation_profile?.address}
                  </div>
                </div>
            </div> 
            {
            item?.offerCount > 0 &&
             <div className="px-4 py-2 rounded-md whitespace-nowrap bg-[#d4ff6eee] text-green-900">
             {item?.offerCount} offres
            </div>
            }
           
        </div>
        <div className='text-level-1 flex-col justify-between text-start mb-4'>
          <TruncateText maxChars={255}>{item?.organisation_profile?.description}</TruncateText>
        </div>
        <div className="flex gap-2 text-sm text-primary-text">
          <div className="border text-semibold px-4 py-2 rounded-full bg-primary-beige  ">{item?.organisation_profile?.category_name}</div>
        </div>
    </div>
  )
}

export default RecruiterCard
